import CondPopupView from "./CondPopUpView";
import { useCondPopupViewModel } from "./CondPopUpViewModel";


const PopUp = (props: any) => {
  const vm = useCondPopupViewModel(props);
  return <CondPopupView vm={vm} />
};

export default PopUp;